class Baneado {
    constructor(){
        this.id = 0,
        this.contenido = '',
        this.tipo = 0,
        this.comparador = 0
    }
}


export {
    Baneado
}